/* esm.sh - date-fns@4.1.0/isExists */
function r(e,n,o){let t=new Date(e,n,o);return t.getFullYear()===e&&t.getMonth()===n&&t.getDate()===o}var s=r;export{s as default,r as isExists};
//# sourceMappingURL=isExists.mjs.map